<template>
  <v-dialog
    v-model="dialog"
    max-width="960"
    persistent
  >
    <template #activator="{on}">
        <v-btn
            v-on="on"
        >
           Manual Picking
        </v-btn>
    </template>

    <v-card :loading="loading" :disabled="loading">
        <v-card-title>Manual Picking</v-card-title>
        <v-container>
            <v-row>
                <v-col>
                    You can pick manually a product, but it does not remove the product from stock
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Product Name
                                    </th>
                                    <th class="text-left">
                                        Quantity
                                    </th>
                                    <th>
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                v-for="item in box.missingItems"
                                :key="item.id"
                                >
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.quantity }}</td>
                                    <td><v-text-field v-model="manualPick[item.id]" label="Pick" type="number" /> </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-container>
        <v-card-actions>
            <v-btn @click="dialog=false">Cancel</v-btn>
            <v-spacer />
            <v-btn color="primary" @click="pick" :disabled="qtyToPick == 0">Pick</v-btn>
        </v-card-actions>
    </v-card>
  
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    data: () =>({
        dialog:false,
        manualPick:{}
    }),
    props:{
        box:{
            type:Object,
            required:true
        }
    },
    computed:{
        ...mapGetters("pendingbox", ["loading"]),
        qtyToPick(){
            const values = Object.values(this.manualPick)
            return values.length ? Object.values(this.manualPick).reduce((a, b) => parseInt(a) + parseInt(b)) : 0;
        }
    },
    methods:{
        ...mapActions("pendingbox",["manualPicking"]),
        pick(){
            this.manualPicking({
                boxId:this.box.id,
                items:this.manualPick
            }).then( () => {
                this.manualPick=false;
                this.dialog=false;
                this.$emit("refresh");
            })
        }
    }
}
</script>

<style>

</style>